import Opaque from 'ts-opaque'
import { DeviceHwID, DeviceValues, ID, PortFlag } from './models'
import { PortConfig, PortNumber, PortValuesClock, PortValuesEm3Ph, PortValuesEmSimple, PortValuesFwInfo, PortValuesOptimizer, PortValuesOptimizerControl, PortValuesOptimizerPrice, PortValuesOptimizerWeather, PortValuesRelay, PortValuesSolar, PortValuesTemperature } from './ports'
import { ApplianceConfig } from '../classes/appliances/Appliance'

export type Topic = Opaque<string, 'Topic'>

export type EventType = 'update' | 'device' | 'flags' | 'message' | 'system' | 'appliance'

export type MessageValues =
  PortValuesClock |
  PortValuesEmSimple |
  PortValuesEm3Ph |
  PortValuesFwInfo |
  PortValuesRelay |
  PortValuesSolar |
  PortValuesTemperature |
  PortValuesOptimizer |
  PortValuesOptimizerControl |
  PortValuesOptimizerPrice |
  PortValuesOptimizerWeather

export interface UpdateMessage {
  event: EventType
  hw_id: DeviceHwID
  device_id: ID
  port_id: ID
  port_number: PortNumber
  location_id: ID
  values: MessageValues
  version: string
  refresh?: boolean
}
export function isUpdateMessage(obj: unknown): obj is UpdateMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'update'
}

export interface DeviceMessage {
  event: EventType
  hw_id: DeviceHwID
  values: DeviceValues
  version?: string
}
export function isDeviceMessage(obj: unknown): obj is DeviceMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'device'
}

export interface FlagMessage {
  event: EventType
  device_id: ID
  port_id: ID
  flags: PortFlag[]
}
export function isFlagMessage(obj: unknown): obj is FlagMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'flags'
}

export interface ConfigMessage {
  event: EventType
  device_id: ID
  port_id: ID
  config: Partial<PortConfig>
}
export function isConfigMessage(obj: unknown): obj is ConfigMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'config'
}

export interface InfoMessage {
  event: EventType
  type: 'info' | 'warning' | 'error'
  text: string
}
export function isInfoMessage(obj: unknown): obj is InfoMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'message'
}

export interface SystemMessage {
  event: EventType
  alert?: string
  version?: string
}
export function isSystemMessage(obj: unknown): obj is FlagMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'system'
}

// This is only partially defined to be extended later to support full CRUD.
export interface ApplianceMessage {
  event: EventType
  id: ID
  config?: Partial<ApplianceConfig>
}

export function isApplianceMessage(obj: unknown): obj is ApplianceMessage {
  return obj !== null && typeof obj === 'object' && (obj as Record<string, unknown>).event === 'appliance'
}

export type SocketMessage = UpdateMessage | DeviceMessage | InfoMessage | FlagMessage | SystemMessage | ApplianceMessage
